import { Link } from "@inertiajs/react";
import Callout from "@/components/help/Callout";
import Screenshot from "@/components/help/Screenshot";
import PrizeTrackerCard from "@/components/schools/PrizeTrackerCard";
import { PRIZES_FOR_TRACKER } from "@/help/fixtures";

export default function HandingOutStudentPrizes() {
  return (
    <>
      <p>
        Earning a prize and actually getting handed one are two different things. PagePledge tracks both — when a student hits the number, they show up on your prize tracker as waiting. Once you hand the prize over in real life, you mark it done.
      </p>

      <h2>Where it is</h2>
      <p>
        Teachers, the prize tracker is on your classroom dashboard. School admins, you can see every classroom at once from the <strong>Prize report</strong> on your <Link href="/help/articles/setting-student-prizes">Student prizes</Link> page.
      </p>

      <Screenshot
        caption="The prize tracker"
        padded={false}
      >
        <div className="p-4 md:p-5">
          <PrizeTrackerCard prizes={PRIZES_FOR_TRACKER} />
        </div>
      </Screenshot>

      <h2>How it works</h2>
      <p>
        When a student crosses the line — say, 500 minutes — they appear automatically under "Ready to hand out" with the prize they earned. Once you give them the fidget spinner (or whatever the prize is), click <strong>Mark handed out</strong>. They move down to "Handed out" and your school's prize report ticks up. Handing out a whole class's worth at once? <strong>Mark all handed out</strong> does every waiting student for that prize.
      </p>

      <p>
        <strong>Top student</strong> winners appear when the campaign finishes, and prize draw winners appear once they're drawn. Each one shows on their own teacher's tracker, even when they won across a division or the whole school. Top student winners have a printable certificate there; draw winners' certificates are on the prize report.
      </p>

      <p>
        Clicked too soon, or marked the wrong student? Every handed-out row has an <strong>Undo</strong> button to flip it back — on your tracker and on the prize report.
      </p>

      <Callout variant="tip" title="Make it a Friday routine">
        <p>
          Spending five minutes on Fridays going through the tracker stops a backlog from piling up.
        </p>
      </Callout>

      <h2>What's next</h2>
      <ul>
        <li><Link href="/help/articles/setting-student-prizes">Setting up student prizes</Link>.</li>
        <li><Link href="/help/articles/teacher-classroom-dashboard">Your classroom dashboard</Link>.</li>
      </ul>
    </>
  );
}
